export default "__VITE_ASSET__DaaLLfxV__"